import { Injectable } from '@angular/core';
import { HttpClientService } from '@app/core/http-client/http-client.service';
import { services } from '@app/core/settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotifacationService {

  private static readonly endpoint = 'Notification';
  constructor(private http: HttpClientService) { }

  getInternationalOrdersNotifications():Observable<any> {
    return this.http.get(`${NotifacationService.endpoint}/GetInternationalOrdersNotifications`, undefined, services.orderService)
  }

  getUnReadCountOfInternationalOrdersNotifications():Observable<number> {
    return this.http.get(`${NotifacationService.endpoint}/GetUnReadCountOfInternationalOrdersNotifications`, undefined, services.orderService)
  }

  markInternationalOrdersNotificationsAsRead(notificationIdslist: number[]) {
    return this.http.post(notificationIdslist, `${NotifacationService.endpoint}/MarkInternationalOrdersNotificationsAsRead`, undefined, services.orderService);
  }

}
